const { id, log, wrap, delay } = require("../std/index")


// Homepage Slideshow

module.exports = class HomepageSlideshow {
  constructor($host, config) {
    this.activeClass = 'is-active';
    this.advanceTime = 3000;

    this.dom = {
      main: $host,
      slides: $('[data-slideshow-slide]', $host),
      triggers: $('[data-slideshow-trigger]', $host)
    };

    this.state = {
      advance: true,
      timer: 0
    };

    this.dom.triggers.on('click', ({ target }) => {
      this.setActive(target.dataset.slideshowTrigger);
    });

    this.wrap = wrap(0, this.dom.slides.length - 1);
    this.go(0);
  }

  go(ix) {
    this.dom.triggers.removeClass(this.activeClass).eq(ix).addClass(this.activeClass);
    this.dom.slides.removeClass(this.activeClass).eq(ix).addClass(this.activeClass);
    if (this.state.advance) {
      this.state.timer = delay(this.advanceTime, () => this.go(this.wrap(ix + 1)));
    }
  }

  setActive(ix) {
    this.state.advance = false;
    clearTimeout(this.state.timer);
    this.go(ix);
  }
};
